export default "__VITE_ASSET__CyMgv01Y__"